// Normalize the API at the boundary so an older/partial backend cannot crash a page.
export const CURRENCIES = ['RUB', 'USD', 'EUR', 'KZT', 'GBP', 'CNY'];
export const DEFAULT_PREFERENCES = { default_currency: 'RUB', default_view: 'overview', hide_amounts: false, show_month_summary: true, compact_cards: false, collapsed_sections: {} };
const VIEWS = ['overview', 'entries', 'projects', 'rules', 'accounts', 'settings'];
const KIND_NAMES = { client: 'Клиентский проект', personal: 'Свой проект', support: 'Поддержка', other: 'Другое' };
const object = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

export function normalizeCatalog(value) {
  const raw = object(value) ? value : {};
  const rows = (key) => Array.isArray(raw[key]) ? raw[key].filter(object) : [];
  const prefs = object(raw.preferences) ? raw.preferences : {};
  const collapsed = object(prefs.collapsed_sections) ? Object.fromEntries(Object.entries(prefs.collapsed_sections).filter(([, v]) => typeof v === 'boolean')) : {};
  const preferences = {
    ...DEFAULT_PREFERENCES,
    default_currency: CURRENCIES.includes(prefs.default_currency) ? prefs.default_currency : 'RUB',
    default_view: VIEWS.includes(prefs.default_view) ? prefs.default_view : 'overview',
    hide_amounts: typeof prefs.hide_amounts === 'boolean' ? prefs.hide_amounts : false,
    show_month_summary: typeof prefs.show_month_summary === 'boolean' ? prefs.show_month_summary : true,
    compact_cards: typeof prefs.compact_cards === 'boolean' ? prefs.compact_cards : false,
    collapsed_sections: collapsed,
  };
  const currencies = Array.isArray(raw.currencies) ? raw.currencies.filter((c) => CURRENCIES.includes(c)) : [];
  return {
    ...raw, initialized: raw.initialized === true,
    supports_customization: Array.isArray(raw.project_types) && object(raw.preferences),
    currencies: currencies.length ? currencies : [...CURRENCIES], preferences,
    accounts: rows('accounts'), categories: rows('categories'), rules: rows('rules'), project_types: rows('project_types'),
    projects: rows('projects').map((p) => ({ ...p, project_type_name: typeof p.project_type_name === 'string' ? p.project_type_name : KIND_NAMES[p.kind] || 'Без типа' })),
  };
}
